async function postJson(path, body, token) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || data?.success === false) {
    throw new Error(data?.message || "Request failed");
  }
  return data;
}

export async function getQuizStages({ currentTheme, organizationId, sessionId, token }) {
  return postJson("/getQuizStages", { currentTheme, organizationId, sessionId }, token);
}

export async function saveQuizStages({ currentTheme, organizationId, sessionId, token, stages }) {
  return postJson("/saveQuizStages", { currentTheme, organizationId, sessionId, stages }, token);
}

export async function saveQuizStageQuestions({
  currentTheme,
  organizationId,
  sessionId,
  token,
  stageId,
  questions,
}) {
  return postJson(
    "/saveQuizStageQuestions",
    { currentTheme, organizationId, sessionId, stageId, questions },
    token
  );
}
